/* ==========================================================================
   Thumb Works theme

   Ported from the static prototype. The cart now talks to Shopify's AJAX
   Cart API instead of localStorage; everything else (drawer, clicker toy,
   gallery, variant chips, quick order maths) behaves as it did.
   ========================================================================== */

(function () {
  'use strict';

  var routes = (window.Theme && window.Theme.routes) || {};
  var moneyFormat = (window.Theme && window.Theme.moneyFormat) || '${{amount}}';

  function money(cents) {
    var value = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (r) {
      if (!r.ok) throw new Error(r.status + ' ' + url);
      return r.json();
    });
  }

  /* ------------------------------------------------------------- drawer */

  var drawer = document.getElementById('cart-drawer');
  var scrim = document.getElementById('drawer-scrim');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('open');
    if (scrim) scrim.classList.add('open');
    document.body.style.overflow = 'hidden';
    var close = document.getElementById('drawer-close');
    if (close) close.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (scrim) scrim.classList.remove('open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function renderCart(cart) {
    var badge = document.getElementById('cart-count');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0;
    }

    var body = document.getElementById('drawer-body');
    var foot = document.getElementById('drawer-foot');
    if (!body) return;

    if (!cart.items.length) {
      body.innerHTML =
        '<div class="cart-empty">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">' +
        '<circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/>' +
        '<path d="M2 3h3l2.6 12.4a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.2L21 7H6"/></svg>' +
        '<p>Nothing here yet.</p></div>';
      if (foot) foot.hidden = true;
      return;
    }

    body.innerHTML = cart.items.map(function (item, i) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_132x$1$2') + '" alt="" width="66" height="66" loading="lazy">'
        : '';
      var variant = item.variant_title && item.variant_title.indexOf('Default') === -1
        ? '<div class="variant">' + item.variant_title + '</div>' : '';
      return '<div class="cart-line">' + img +
        '<div class="info"><b>' + item.product_title + '</b>' + variant +
        '<div class="qty">' +
        '<button class="qty-btn" type="button" data-line="' + (i + 1) + '" data-to="' + (item.quantity - 1) + '" aria-label="Remove one">&minus;</button>' +
        '<span aria-live="polite">' + item.quantity + '</span>' +
        '<button class="qty-btn" type="button" data-line="' + (i + 1) + '" data-to="' + (item.quantity + 1) + '" aria-label="Add one">+</button>' +
        '</div></div>' +
        '<div class="line-price">' + money(item.final_line_price) + '</div></div>';
    }).join('');

    if (foot) {
      foot.hidden = false;
      var total = document.getElementById('drawer-total');
      if (total) total.textContent = money(cart.total_price);

      var ship = document.getElementById('drawer-ship');
      var threshold = parseInt(document.body.dataset.freeShipping || '0', 10);
      if (ship) {
        if (threshold > 0 && cart.total_price < threshold) {
          ship.textContent = money(threshold - cart.total_price) + ' away from free US shipping.';
        } else if (threshold > 0) {
          ship.textContent = 'Free US shipping unlocked.';
        } else {
          ship.textContent = 'Shipping and taxes calculated at checkout.';
        }
      }
    }
  }

  function refreshCart(open) {
    return fetchJSON(routes.cart + '.js').then(function (cart) {
      renderCart(cart);
      if (open) openDrawer();
      return cart;
    });
  }

  function addToCart(formData) {
    return fetch(routes.cart_add, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        return data;
      });
    });
  }

  function changeLine(line, quantity) {
    return fetchJSON(routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (cart) {
      renderCart(cart);
      return cart;
    });
  }

  /* -------------------------------------------------------------- events */

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('#cart-open');
    if (openBtn) { e.preventDefault(); refreshCart(true); return; }

    if (e.target.closest('#drawer-close') || e.target.closest('#drawer-scrim')) {
      closeDrawer(); return;
    }

    var qty = e.target.closest('[data-line]');
    if (qty) { e.preventDefault(); changeLine(Number(qty.dataset.line), Number(qty.dataset.to)); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('open')) closeDrawer();
    var nav = document.getElementById('primary-nav');
    var toggle = document.getElementById('nav-toggle');
    if (nav && nav.classList.contains('open')) {
      nav.classList.remove('open');
      if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
    }
  });

  // Quick-add on cards and the product form both submit through AJAX.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add], [data-product-form]');
    if (!form) return;
    e.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    if (button) { button.disabled = true; button.dataset.label = button.textContent; button.textContent = 'Adding…'; }

    addToCart(new FormData(form))
      .then(function () { return refreshCart(true); })
      .catch(function (err) { alert(err.message); })
      .then(function () {
        if (button) { button.disabled = false; button.textContent = button.dataset.label; }
      });
  });

  /* ------------------------------------------------------------ nav menu */

  var navToggle = document.getElementById('nav-toggle');
  if (navToggle) {
    navToggle.addEventListener('click', function () {
      var nav = document.getElementById('primary-nav');
      var open = nav.classList.toggle('open');
      navToggle.setAttribute('aria-expanded', String(open));
    });
  }

  /* --------------------------------------------------------- clicker toy */

  var clicker = document.getElementById('clicker-btn');
  var clickerOut = document.getElementById('clicker-count');
  if (clicker && clickerOut) {
    var n = 0;

    /* The click is synthesised rather than loaded from an mp3: the whole sound
       is eight milliseconds, so a file request would cost more than the audio is
       worth and the first press would be silent while it downloaded.

       A real switch is a noise transient, not a tone — a short burst of filtered
       noise through a fast decay. Press and release get slightly different
       filter frequencies, the way the two halves of a switch actually differ. */
    var audio = null;
    var noise = null;

    function ready() {
      var Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return false;
      /* Browsers only allow an AudioContext to start inside a user gesture. */
      if (!audio) {
        audio = new Ctx();
        var frames = Math.floor(audio.sampleRate * 0.05);
        noise = audio.createBuffer(1, frames, audio.sampleRate);
        var data = noise.getChannelData(0);
        for (var i = 0; i < frames; i++) data[i] = Math.random() * 2 - 1;
      }
      if (audio.state === 'suspended') audio.resume();
      return true;
    }

    function tick(freq, gain, decay) {
      if (!ready()) return;
      var t = audio.currentTime;

      var src = audio.createBufferSource();
      src.buffer = noise;

      var band = audio.createBiquadFilter();
      band.type = 'bandpass';
      band.frequency.value = freq;
      band.Q.value = 1.4;

      var vol = audio.createGain();
      vol.gain.setValueAtTime(gain, t);
      vol.gain.exponentialRampToValueAtTime(0.0001, t + decay);

      src.connect(band).connect(vol).connect(audio.destination);
      src.start(t);
      src.stop(t + decay + 0.01);
    }

    /* Down and up are bound separately so holding the button gives you the two
       distinct halves of the click, exactly like the switch inside the product. */
    clicker.addEventListener('pointerdown', function () { tick(2400, 0.32, 0.03); });
    clicker.addEventListener('pointerup', function () { tick(1500, 0.16, 0.02); });

    clicker.addEventListener('click', function () { clickerOut.textContent = ++n; });

    /* Keyboard activation never fires pointer events, so it would be silent.
       Holding the key repeats keydown, hence the e.repeat guard. */
    clicker.addEventListener('keydown', function (e) {
      if (e.repeat) return;
      if (e.key === ' ' || e.key === 'Enter') tick(2400, 0.32, 0.03);
    });
    clicker.addEventListener('keyup', function (e) {
      if (e.key === ' ' || e.key === 'Enter') tick(1500, 0.16, 0.02);
    });
  }

  /* ------------------------------------------------------------- gallery */

  var thumbs = document.getElementById('pdp-thumbs');
  if (thumbs) {
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-full]');
      if (!b) return;
      var main = document.getElementById('pdp-img');
      if (main) main.src = b.dataset.full;
      thumbs.querySelectorAll('button').forEach(function (x) {
        x.setAttribute('aria-pressed', String(x === b));
      });
    });
  }

  /* ------------------------------------------------------ variant picker */

  var productForm = document.getElementById('product-form');
  if (productForm) {
    var select = document.getElementById('variant-select');
    var chipGroups = productForm.querySelectorAll('[data-option-index]');

    function currentOptions() {
      return Array.prototype.map.call(chipGroups, function (group) {
        var active = group.querySelector('[aria-pressed="true"]');
        return active ? active.dataset.value : '';
      });
    }

    function syncVariant() {
      var wanted = currentOptions().join(' / ');
      var match = Array.prototype.find.call(select.options, function (o) {
        return o.dataset.options === wanted;
      });
      if (!match) return;
      select.value = match.value;

      var price = document.getElementById('pdp-price');
      if (price) price.textContent = match.dataset.price;

      var add = document.getElementById('pdp-add');
      if (add) {
        add.disabled = match.disabled;
        add.textContent = match.disabled ? 'Sold out' : 'Add to cart';
      }
    }

    chipGroups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-value]');
        if (!b) return;
        group.querySelectorAll('button').forEach(function (x) {
          x.setAttribute('aria-pressed', String(x === b));
        });
        var label = group.parentElement.querySelector('[data-current]');
        if (label) label.textContent = b.dataset.value;
        syncVariant();
      });
    });

    var qtyInput = document.getElementById('qty-input');
    function clampQty() {
      var v = parseInt(qtyInput.value, 10);
      if (!isFinite(v) || v < 1) v = 1;
      if (v > 99) v = 99;
      qtyInput.value = v;
    }
    var minus = document.getElementById('qty-minus');
    var plus = document.getElementById('qty-plus');
    if (minus) minus.addEventListener('click', function () { qtyInput.value = Number(qtyInput.value) - 1; clampQty(); });
    if (plus) plus.addEventListener('click', function () { qtyInput.value = Number(qtyInput.value) + 1; clampQty(); });
    if (qtyInput) qtyInput.addEventListener('change', clampQty);
  }

  /* --------------------------------------------------------- quick order */

  var qo = document.getElementById('quick-order');
  if (qo) {
    var minimum = Number(qo.dataset.minimum || 0) * 100;
    var rows = qo.querySelectorAll('[data-row]');

    function unitPriceCents(tiers, qty) {
      var cents = Math.round(tiers[0].price * 100);
      var tierMin = tiers[0].min;
      tiers.forEach(function (t) {
        if (qty >= t.min) { cents = Math.round(t.price * 100); tierMin = t.min; }
      });
      return { cents: cents, tierMin: tierMin };
    }

    function recalc() {
      var units = 0, total = 0, msrp = 0, belowMoq = 0;

      rows.forEach(function (row) {
        var tiers = JSON.parse(row.dataset.tiers);
        var moq = Number(row.dataset.moq);
        var input = row.querySelector('[data-qty]');
        var qty = Math.max(0, parseInt(input.value, 10) || 0);

        var priced = unitPriceCents(tiers, qty);
        row.querySelector('[data-unit]').textContent = money(priced.cents);
        row.querySelector('[data-line]').textContent = qty ? money(priced.cents * qty) : '—';

        if (qty > 0) {
          units += qty;
          total += priced.cents * qty;
          msrp += Number(row.dataset.msrp) * qty;
          if (qty < moq) belowMoq++;
        }
      });

      document.getElementById('qo-units').textContent = units;
      document.getElementById('qo-total').textContent = money(total);
      document.getElementById('qo-msrp').textContent = money(msrp);

      var note = document.getElementById('qo-note');
      var submit = document.getElementById('qo-submit');

      if (belowMoq) {
        note.textContent = belowMoq + (belowMoq === 1 ? ' line is' : ' lines are') + ' below the minimum quantity.';
        note.className = 'qo-warn';
        submit.disabled = true;
      } else if (total > 0 && total < minimum) {
        note.textContent = money(minimum - total) + ' below the ' + money(minimum) + ' first-order minimum.';
        note.className = 'qo-warn';
        submit.disabled = true;
      } else if (total === 0) {
        note.textContent = 'Enter quantities to build your order.';
        note.className = 'qo-tier';
        submit.disabled = true;
      } else {
        note.textContent = 'Ready to add to your order.';
        note.className = 'qo-tier';
        submit.disabled = false;
      }
    }

    qo.addEventListener('input', function (e) {
      if (e.target.matches('[data-qty]')) recalc();
    });

    // Drop empty lines so Shopify does not reject the bulk add.
    qo.addEventListener('submit', function (e) {
      e.preventDefault();
      var items = [];
      rows.forEach(function (row) {
        var qty = parseInt(row.querySelector('[data-qty]').value, 10) || 0;
        if (qty > 0) {
          items.push({ id: Number(row.querySelector('input[type="hidden"]').value), quantity: qty });
        }
      });
      if (!items.length) return;

      fetchJSON(routes.cart_add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function () { return refreshCart(true); })
        .catch(function (err) { alert(err.message); });
    });

    recalc();
  }

  /* --------------------------------------------------------- colour dots */

  var SWATCHES = {
    blush: '#F7B8CE', pistachio: '#C7E3B0', lemon: '#FFE699', lavender: '#CFC0EE',
    peach: '#FFC9A8', vanilla: '#FBF0DC', strawberry: '#F5849A', chocolate: '#8C5A3C',
    blueberry: '#8E9BD8', mint: '#9FE3C6', bubblegum: '#F9A8C8', golden: '#E5B45E',
    salmon: '#FF9E6E', tuna: '#E4626B', egg: '#FFD98A', sand: '#E6D2AF',
    calico: '#F3E4D2', ginger: '#E39A5B', tuxedo: '#3B3B3B', dog: '#C99A6B',
    cat: '#E8935B', penguin: '#2F4257', parrot: '#5CA85C', macaw: '#D6453F',
    sage: '#A9BCA5', midnight: '#332F45', terracotta: '#C0714E', lilac: '#C5AEE0',
    charcoal: '#4A4A4A', cream: '#F6E7CE', raspberry: '#D6417A', periwinkle: '#B4BDE8'
  };

  document.querySelectorAll('[data-swatch]').forEach(function (el) {
    var name = el.dataset.swatch;
    var hit = SWATCHES[name];
    if (!hit) {
      Object.keys(SWATCHES).some(function (k) {
        if (name.indexOf(k) !== -1) { hit = SWATCHES[k]; return true; }
        return false;
      });
    }
    el.style.background = hit || '#DCCFC2';
  });

  // Prime the drawer so the badge and contents are correct on first open.
  if (document.getElementById('drawer-body')) refreshCart(false);
})();
